import React from 'react';
import ReactDOM from 'react-dom';
import { AutoDealers } from './app/components';

const App = () => <AutoDealers />;

ReactDOM.render(<App />, document.getElementById('app-auto-dealers'));
